/**
 * Product recommendations — the upsell rows on the product page.
 *
 * Shopify renders them through the Section Rendering API, one request per
 * intent (related, then complementary); each response is this section with
 * `recommendations.products` filled in. Rows land in the order of the
 * intents setting; an intent with nothing to show adds nothing. Nothing is
 * requested twice, and a late response never lands on another product.
 */
(function () {
  'use strict';

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  async function fetchRow(root, intent) {
    const url = `${ROOT}recommendations/products?section_id=${encodeURIComponent(root.dataset.sectionId)}&product_id=${encodeURIComponent(root.dataset.productId)}&limit=${encodeURIComponent(root.dataset.limit || '8')}&intent=${encodeURIComponent(intent)}`;
    const res = await fetch(url);
    // Shopify answers 404 for an intent with nothing to recommend (complementary
    // products not set up yet): that is "no row", not an error.
    if (res.status === 404) return null;
    if (!res.ok) throw new Error(`recommendations ${res.status}`);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('[data-recommendations-row]');
  }

  async function load(root) {
    if (root.dataset.recommendationsLoaded) return;
    root.dataset.recommendationsLoaded = 'true';
    const intents = (root.dataset.intents || 'related').split(',').map((s) => s.trim()).filter(Boolean);
    const productId = root.dataset.productId;
    for (const intent of intents) {
      try {
        const row = await fetchRow(root, intent);
        if (root.dataset.productId !== productId) return; // the page moved on
        if (row && row.querySelector('.product-card')) root.append(row);
      } catch (err) {
        console.error('[product-recommendations]', intent, err);
      }
    }
    root.toggleAttribute('data-recommendations-empty', !root.querySelector('[data-recommendations-row]'));
  }

  function boot() {
    document.querySelectorAll('[data-product-recommendations]').forEach((root) => load(root));
  }

  window.ProductRecommendations = { load, boot };
  if (document.readyState === 'complete') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
